var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "el-dialog",
        {
          staticStyle: { "'margin-top": "15vh'" },
          attrs: {
            title: this.ceTitle,
            visible: _vm.show,
            "modal-append-to-body": false,
            width: "850px",
            "close-on-click-modal": false,
            "before-close": _vm.cancelHandle
          },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "codeForm",
              staticClass: "xForm",
              attrs: {
                model: _vm.codeForm,
                rules: _vm.rules,
                "label-width": "4em",
                center: ""
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: "类型", prop: "qrType" },
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function() {
                        return [
                          _c("div", { staticClass: "my-label" }, [
                            _vm._v("类型")
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { disabled: _vm.onlySee },
                      on: { change: _vm.typeChange },
                      model: {
                        value: _vm.codeForm.qrType,
                        callback: function($$v) {
                          _vm.$set(_vm.codeForm, "qrType", $$v)
                        },
                        expression: "codeForm.qrType"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: "1" } }, [
                        _vm._v("批量单人")
                      ]),
                      _c("el-radio", { attrs: { label: "0" } }, [
                        _vm._v("单人")
                      ]),
                      _c("el-radio", { attrs: { label: "2" } }, [
                        _vm._v("多人")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "el-tags-wrap",
                  attrs: { label: "使用人员", prop: "userList" }
                },
                [
                  _vm._l(_vm.userMembenNames, function(item) {
                    return _c(
                      "el-tag",
                      {
                        key: item.id,
                        staticStyle: { "margin-right": "4px" },
                        attrs: { closable: !_vm.onlySee, type: "small" },
                        on: {
                          close: function($event) {
                            return _vm.delSelectedHandle(item)
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(item.name) + " ")]
                    )
                  }),
                  !_vm.onlySee
                    ? _c(
                        "el-button",
                        {
                          staticClass: "tags-btn",
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              return _vm.clickAddMember()
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.userMenberList.length != 0 ? "修改" : "添加"
                            )
                          )
                        ]
                      )
                    : _vm._e()
                ],
                2
              ),
              _c(
                "el-form-item",
                { attrs: { label: "添加设置", prop: "skipVerify" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      attrs: { disabled: _vm.onlySee },
                      model: {
                        value: _vm.codeForm.skipVerify,
                        callback: function($$v) {
                          _vm.$set(_vm.codeForm, "skipVerify", $$v)
                        },
                        expression: "codeForm.skipVerify"
                      }
                    },
                    [_vm._v("客户添加时无需确认自动成为好友")]
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "使用场景", prop: "sceneName" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: {
                      disabled: _vm.onlySee,
                      clearable: "",
                      autocomplete: "off",
                      size: "small",
                      maxlength: "30",
                      "show-word-limit": ""
                    },
                    model: {
                      value: _vm.codeForm.sceneName,
                      callback: function($$v) {
                        _vm.$set(_vm.codeForm, "sceneName", $$v)
                      },
                      expression: "codeForm.sceneName"
                    }
                  })
                ],
                1
              ),
              !_vm.onlySee
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "el-tags-wrap",
                      attrs: { label: "扫码标签", prop: "tagIdList" }
                    },
                    [
                      _vm._l(_vm.selecteTagsList, function(item) {
                        return _c(
                          "el-tag",
                          {
                            key: item.tagId,
                            attrs: { type: "small", closable: "" },
                            on: {
                              close: function($event) {
                                return _vm.delSelectedTags(item.tagId)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.tagName))]
                        )
                      }),
                      _c(
                        "el-button",
                        {
                          staticClass: "tags-btn",
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              return _vm.addTagsHandle()
                            }
                          }
                        },
                        [_vm._v("添加")]
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "welcome-form-item",
                  attrs: { label: "欢迎语", prop: "welcomeContent" }
                },
                [
                  _vm.editData == null
                    ? _c("MyUpload", {
                        ref: "myUpload",
                        attrs: { myType: 4 },
                        on: { receiveParam: _vm.receiveParam }
                      })
                    : _c("MyUploadDetail", {
                        attrs: { myType: 4, upLoadData: _vm.upLoadData }
                      })
                ],
                1
              )
            ],
            1
          ),
          !_vm.onlySee
            ? _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-right": "20px" },
                      attrs: { size: "small" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                          return _vm.cancelHandle()
                        }
                      }
                    },
                    [_vm._v("返 回")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "primary",
                        size: "small",
                        disabled: _vm.confirmDisable
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmHandle()
                        }
                      }
                    },
                    [_vm._v("确 定")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _c("StaffTree", {
        ref: "myStaffTree1",
        attrs: {
          title: _vm.title,
          dialogVisibleTree: _vm.dialogVisibleTree1,
          currentSelectMember: _vm.userMenberList
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      }),
      _c("StaffTreeTwo", {
        ref: "myStaffTree0",
        attrs: {
          title: _vm.title,
          dialogVisibleTree: _vm.dialogVisibleTree0,
          currentSelectMember: _vm.userMenberList,
          treeType: 2,
          oldSelectTitle: ""
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      }),
      _c("StaffTree", {
        ref: "myStaffTree2",
        attrs: {
          title: _vm.title,
          dialogVisibleTree: _vm.dialogVisibleTree2,
          currentSelectMember: _vm.userMenberList
        },
        on: { closeTree: _vm.closeTree, clickSubmitTree: _vm.clickSubmitTree }
      }),
      _c("AddTagsDia", {
        attrs: {
          tagsDislogVisible: _vm.tagsDislogVisible,
          selecteTagsList: _vm.selecteTagsList
        },
        on: {
          tagsCloseHandle: _vm.tagsCloseHandle,
          tagsConfirmHandle: _vm.tagsConfirmHandle
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }